import {Component, OnInit} from '@angular/core';
import {CrudUserService} from '../../../../shared/services/crud-user.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {ShareddataService} from '@shared/services/shareddata.service';
import {CrudCompaniesService} from '@shared/services/crud-companies.service';

@Component({
  selector: 'app-users-tools-list',
  templateUrl: './users-tools-list.component.html',
  styleUrls: ['./users-tools-list.component.scss']
})
export class UsersToolsListComponent implements OnInit {

  observabledata: Observable<any>;
  displayedcolumns: IDisplayColumn[] = [];
  entityroot: string;

  constructor(protected httpcrud: CrudUserService, // Specific
              protected companyService: CrudCompaniesService,
              protected modalservice: BsModalService,
              private router: Router,
              private route: ActivatedRoute,
              private sharedData: ShareddataService
  ) {
    const userid = this.route.snapshot.paramMap.get('id');
    this.entityroot = '/admin/users/' + userid + '/usertoolconfigs';
  } // constructor

  ngOnInit() {
    const userid = this.route.snapshot.paramMap.get('id');

    this.observabledata = this.httpcrud.getUsertools(userid);

    this.displayedcolumns = [
      {columnName: 'id', isKeyColumn: true, label: 'ID'},
      {columnName: 'toolid', label: 'Tool ID'},
      {columnName: 'toolname', label: 'Tool'},
      {columnName: 'companylabel', label: 'Company'},
    ] as IDisplayColumn[];
  } // ngOnInit

  getObservableData() {
    return this.observabledata;
  }

  getPostTreatmentCallback() {
    return (data) => {
      return data.results;
    };
  }

  getListEditPathCallback() {
    return (idvalue) => this.entityroot + '/' + idvalue + '/edit';
  }

  getCreateLink() {
    return [this.entityroot + '/create'];
  }

  goToUserList() {
    this.router.navigate(['/admin/users']);
  }

  deleteEntityHandler(): any {
    return (idvalue) => {
      return this.companyService.removeUserTool(idvalue);
    };
  }

  deletePostTreatmentHandler() {
    return (idvalue, entityroot) => {
      // Refresh same page
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([entityroot]));
    };
  } // deletePostTreatmentHandler

}
